export default __webpack_public_path__ + "static/news30-915a6dabe66098bc529988189d3205e2.avif";